<template>

  <f7-page class="no-swipeback" login-screen @page:reinit id="login">
    <div class="body hideScrollbar">
        <div v-if="isLargeScreen">
          <f7-navbar>
            <f7-nav-left>
            </f7-nav-left>
            <f7-nav-center class="titleApp" sliding>
              <div class="logo-browser">
                <p class="logoHomepage"><img class="logoBigScreen" src="./../../assets/static/images/logo/moneyroad_green.svg"/></p>
              </div>
            </f7-nav-center>
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
        </div>
        <div class="row registerForm">
          <div class="col-lg-4 offset-lg-4">
            <div class="panel21 panel-default loginPanel loginHeight">
                <p class="displayimg col-sm showSmallScreenOnly">
                  <img class="logoSmallScreen" src="./../../assets/static/images/MoneyRoadLogo3.png"></img>
                <div class="panel-heading ajust col-md-10 offset-md-1">
                    <h3 class="panel-title" v-if="!activationCode">{{ $t('loginPage.sign_in_activated') }}</h3>
                    <h3 class="panel-title" v-if="activationCode">{{ $t('loginPage.sign_in_not_activated') }}</h3>
                </div>
                <div v-on:keyup.enter="QuickLogin()">
                  <f7-list form class="loginForm">
                    <f7-list-item class="loginListhideBorder col-md-12">
                      <f7-input @keyup.enter="$event.target.blur()" class="userInput" name="username" :placeholder="loginpage_Identifier" type="email" :title="loginpage_UnvalidEmail" v-model="credentials.Login"></f7-input>
                    </f7-list-item>
                    <f7-list-item class="loginListhideBorder col-md-12">
                      <f7-input @keyup.enter="$event.target.blur()" class="userInput" name="password" type="password" :placeholder="loginpage_Password" v-model="credentials.Password"></f7-input>
                      <i class="icon-eye_blind icon icon-password" @click="toggleVisibility" style='right: 0px;position: absolute;'></i>
                    </f7-list-item>
                  </f7-list>
                </div>

                <f7-list class="loginButtons col-sm-4">
                  <!-- <f7-list-button v-if="accesAccount" link="/account/" title="Login" link-view="#main-page">Login</f7-list-button> -->
                  <f7-list-button class="logButton loginButton" @click="authUser()" color="white">
                    <i class="fa fa-sign-in"></i>
                    {{ $t('loginPage.lgn') }}
                  </f7-list-button>
                  <f7-list-button class="logButton loginButton" @click="handleClickSignIn" color="white">
                    <i class="fa fa-google"></i>
                    {{ $t('loginPage.login_ggl') }}
                  </f7-list-button>
                  <!-- <f7-list-button class="logButton" id="Register" title="Register" open-popup="#register-screen">Register</f7-list-button> -->
                  <f7-list-button class="logButton loginButton" link="/register/" color="white">
                    <i class="icon-edit_white icon icon-float-sub-button"></i>
                    {{ $t('common.rgstr') }}
                  </f7-list-button>
                  <!-- <center class="termConditionColor termConditionTop">{{ $t('loginPage.before_terms_phrase') }}</center> -->
                  <!-- <center class="termConditionColor">{{ $t('loginPage.terms_cdts') }}</center> -->
                </f7-list>
                <cm-account-activation-popup v-bind:credentials="credentials"></cm-account-activation-popup>
            </div>
          </div>
        </div>
    </div>

  </f7-page>
</template>

<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
// import {getServiceName} from '@/helpers/services'
import _ from 'underscore'
import CMAccountActivation from '@/popups/user/CMAccountActivation.vue'
// import $ from 'jquery'

// import MainPage from '@/components/account/CMMainPage.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'login',
  components: {
    'cm-account-activation-popup': CMAccountActivation
  },
  data: () => {
    return {
      credentials: {
        Login: '',
        Password: '',
        ConnectBy: false,
        'Biometrics': {
          'Voice': 'string',
          'Video': 'string',
          'Fingerprint': 'string'
        }
      },
      isLargeScreen: true,
      activationCode: '',
      defaultUrl: '/directDebit/inbox/'
    }
  },
  created () {
    this.loginpage_Identifier = this.$i18n.t('common.idtfr')
    this.loginpage_Password = this.$i18n.t('common.pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isLargeScreen = false
    }
    this.$bus.$off('refresh-inbox-list-cache')
    var currentUrl = window.location.pathname
    currentUrl = currentUrl.split('/')
    if (currentUrl.length > 1 && currentUrl[1] !== 'android_asset') {
      this.activationCode = currentUrl[1]
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('LogIn', true)
      loadPage(this, {url: this.defaultUrl})
    }
  },
  methods: {
    connect () {
      /* TLV 18/08/2020
      * On précise ici le nom du service et son URL par défaut associées */
      let defaultService = 'Direct Debit'
      let defaultServiceId = parseInt(this.$engine.services.getServiceIdByName(defaultService)) - 1
      let that = this
      that.$engine.services
      .enroll(1, moment('2020-06-10', 'YYYY-MM-DD'))
      .then(response => {
        if (response.status === 200) {
          this.$bus.emit('service:change', defaultService)
          this.$bus.emit('LogIn', true)
          that.$f7.hidePreloader()
          this.$bus.emit('refresh-cache-menu')
          this.$$('.panel-overlay').css('z-index', '')
          this.$$('.deleteNavBar').removeClass('deleteNavBar')
          // let serviceInbox = '/payments/inbox/'
          // loadPage(that, {url: serviceInbox})
          // that.$f7.popup('#service-switcher-true')
          if (this.$engine.user.getIsFirstLogin() === '1') {
            this.$bus.emit('service:change', defaultService)
            // loadPage(that, {url: '/payments/inbox/'})
            that.$engine.services.payments.update(0, 1, 1,
              {
                statusWaiting: 1
              }
            )
            .then(resp => {
              // if (resp.data.payments.length > 0) {
              //   that.$engine.settings.set({clickedMessage: resp.data.payments[0]})
              //   that.$engine.settings.set({msgFromInbox: true})
              //   that.$engine.user.setIsFirstLogin('0')
              //   loadPage(that, {url: '/directPayments/transaction-details/0/'})
              // } else {
              //   loadPage(that, {url: '/directPayments/inbox/'})
              // }
              /* IRY 04/2020 A la première connexion, on est redirigé vers le dashboard */
              loadPage(that, {url: that.defaultUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          } else {
            switch (this.$engine.user.get().favourite_service) {
              /*
              case '2' :
                this.$bus.emit('service:change', 'Direct Debit')
                loadPage(that, {url: '/directDebit/inbox/'})
                break
                */
              default :
                /* IRY 25/02/2020 On ne redirige plus vers DP inbox mais vers DP dashboard */

                this.$engine.user.changeService(this.$engine.services.get()[defaultServiceId])
                const changeService = new Promise(function (resolve, reject) {
                  loadPage(that, {url: that.defaultUrl})
                  resolve()
                })
                changeService.then(function () {
                  that.$bus.emit('service:change', defaultService)
                })
                // loadPage(that, {url: '/directPayments/inbox/'})

                break
              // TLV 20/01/2020 : Pour la démo, la page d'accueil est la inbox des DP
              /* case '6' :
                this.$bus.emit('service:change', 'Direct Payments')
                loadPage(that, {url: '/directPayments/inbox/'})
                break
              default :
                this.$bus.emit('service:change', 'Payments')
                loadPage(that, {url: '/dashboard/'}) */
            }
          }
        }
      }).catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    authUser () {
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      this.$engine.auth.login(creds)
      .then(resp => {
        this.$engine.user.connectBy = 'login-password-capi'
        that.connect()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        if (this.activationCode.length > 0) {
          this.activateAccount(this.activationCode)
        } else {
          errorMessageAlert(err, this)
        }
      })
    },
    QuickLogin () {
      if (this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0) {
        this.authUser()
      }
    },
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      const that = this
      if (code !== '') {
        this.$engine.auth.activate(code)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('icon-eye_blind')) {
        that.Dom7($event.target).removeClass('icon-eye_blind')
        that.Dom7($event.target).addClass('icon-eye')
        that.Dom7($event.target).parent().find('input').prop('type', 'text')
      } else {
        that.Dom7($event.target).removeClass('icon-eye')
        that.Dom7($event.target).addClass('icon-eye_blind')
        that.Dom7($event.target).parent().find('input').prop('type', 'password')
      }
    },
    handleClickSignIn () {
      let that = this
      // On se conecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader('Signing in')
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.auth.login(creds)
        .then(resp => {
          // J'existe
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(err => {
            console.log(err)
            // console.log('/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password)
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    }
  }
}
</script>
<style>
.deleteNavBar {
  display: none !important;
}

#login .page-content {
  padding-top: 0px !important;
}

.list-block .list-button {
  padding: 0;
}
.userInput {
  margin-left: 10%;
  margin-right: 10%;
  border-bottom-style: solid;
  border-width: 1px;
  border-color: #888888;
}

.displayimg {
  margin-left: 5%;
  margin-right: 5%;
  align-content: center;
  text-align: center;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.panel-heading.ajust {
    padding: 9px 10px 12px 15px;
    border-bottom: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-transform: uppercase;
    margin-right: auto;
    margin-top: 18px;
    margin-left: 13%;
}
.panel-title {
    font-size: 22px;
    display: block;
    border-left: solid 2px #12bcf1;
  padding-left: 8px;
  line-height: 30px;
  color: #000000;
}
.logo-browser {
  margin: 0 auto;
}
@media (min-height: 600px) and (max-width: 992px) {
  .loginHeight {
    padding-bottom: 100%;
  }
}
@media screen and (max-height: 450px) {
  .h-sm-hide {
    display: none;
  }
}

@media (min-width: 993px) {
  .container {
    margin-top: 150px;
  }

  .logoBigScreen {
    width: auto;
    height: auto;
  }
  .body {
    background: #E6E7E8;
  }

  .panel21 {
    border: solid 1px #dbdbdb;
    background: #fcfcfc;
  }
  /* TLV 27/11/2019 : le formulaire de connexion doit être éditable sur grand écran,
    même quand le menu de gauche apparaît */
  .panel-overlay{
    z-index: 1;
  }
}


@media (max-width: 992px){
  .logoSmallScreen {
    width: inherit;
    height: auto;
    margin-left: -11%;
  }
  .panel-heading.ajust  {
    margin-left: auto;
  }
  .body {
    background: #fff;
  }

}


.icon-password {
  width: 28px;
  height: 28px;
}
.panel2, .panel21 {
    float: left;
    width: 100%;
}
.container {
    margin-right: auto;
    margin-left: auto;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
}


.body {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: -80px 215px;
    overflow: hidden;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
}

@media (min-width: 993px) {
  .hideScrollbar {
    overflow-y: hidden !important;
  }
}
</style>



// WEBPACK FOOTER //
// CMLogin.vue?be5759d0